import isNil from 'lodash/isNil'

export default value => {
  if (!isNil(value) && value !== '') return true

  return false
}
